import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState } from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import useAppContext from 'flow/hooks/useAppContext';
import { useHistory, useParams } from 'react-router-dom';
import { getCtiSetting, setCtiSetting, CTI_SETTINGS_OPEN_ON_CALL, CTI_SETTINGS_LABEL } from 'flow/utils/cti-settings-utils';
import { addCtiLogEntry } from 'flow/utils/browser-utils';
import { routes } from 'flow/types/routes';
import Page from 'flow/components/Setting/Page';
import RadioButton from 'flow/components/ui-components/RadioButton';
import Divider from 'flow/components/ui-components/Divider';
import { CTI_LIST_SETTINGS_VALUE_LABELS } from 'flow/types/CTISettings';
import { generatePath } from 'flow/utils/router-utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var OpenOnCall = function OpenOnCall() {
  var _useAppContext = useAppContext(),
    i18next = _useAppContext.i18next;
  var history = useHistory();
  var _useParams = useParams(),
    extensionKey = _useParams.extensionKey;
  var settings = useAppSelector(getCtiSetting);
  var _useState = useState(settings.openOnCall.value),
    _useState2 = _slicedToArray(_useState, 2),
    selectedOption = _useState2[0],
    setSelectedOption = _useState2[1];
  var updateSetting = function updateSetting(uniqueId) {
    setSelectedOption(uniqueId);
    addCtiLogEntry("setting openOnCall was changed to ".concat(uniqueId));
    setCtiSetting(_objectSpread(_objectSpread({}, settings), {}, {
      openOnCall: {
        value: uniqueId
      }
    }));
  };
  var getOption = function getOption(option, translation) {
    return /*#__PURE__*/_jsx(RadioButton, {
      checked: selectedOption === option,
      name: option,
      onChange: function onChange() {
        return updateSetting(option);
      },
      children: i18next.t(translation)
    });
  };
  return /*#__PURE__*/_jsxs(Page, {
    header: i18next.t(CTI_SETTINGS_LABEL.openOnCall),
    onClickBack: function onClickBack() {
      return history.push(generatePath(routes['settings.cti-settings'], {
        extensionKey: extensionKey
      }));
    },
    children: [getOption(CTI_SETTINGS_OPEN_ON_CALL.OFF, CTI_LIST_SETTINGS_VALUE_LABELS.openOnCall.off), getOption(CTI_SETTINGS_OPEN_ON_CALL.OPEN_CONTACT, CTI_LIST_SETTINGS_VALUE_LABELS.openOnCall.open_contact), /*#__PURE__*/_jsx(Divider, {})]
  });
};
export default OpenOnCall;